import { Badge, Button, Typography } from '@lucid/lego';
import { ProspectTestDrive } from '../../../../../../api/services/lupp/prospect/dto.test-drive-schedule';
import { formatDateTimeRange } from '../../../../../../utils/tools';
import {
  formatTestDriveVehicle,
  getTestDriveStatusBadgeColor,
  getTestDriveStatusLabel,
} from '../utils';

type CreateColumnsParams = {
  theme: 'light' | 'dark';
  onViewClick: (record: ProspectTestDrive) => void;
  labels: Record<string, string>;
  locale?: string;
};

export const createColumns = ({
  theme,
  onViewClick,
  labels,
  locale = 'en-US',
}: CreateColumnsParams) => [
  {
    key: 'vehicle',
    title: labels.vehicle || 'Vehicle',
    width: '200px',
    sortable: true,
    render: (_: unknown, record: ProspectTestDrive) => (
      <Typography variant="body" size="small" color="black" theme={theme}>
        {formatTestDriveVehicle(record.make, record.model, record.trim) || '-'}
      </Typography>
    ),
  },
  {
    key: 'scheduledStartDatetime',
    title: labels.scheduled_for || 'Scheduled For',
    width: '180px',
    sortable: true,
    render: (_: unknown, record: ProspectTestDrive) => (
      <Typography variant="body" size="small" color="black" theme={theme}>
        {formatDateTimeRange(
          record.scheduledStartDatetime,
          record.scheduledEndDatetime,
          locale,
          undefined,
          record.timezone
        )}
      </Typography>
    ),
  },
  {
    key: 'appointmentLocationName',
    title: labels.location || 'Location',
    width: '200px',
    sortable: true,
    render: (_: unknown, record: ProspectTestDrive) => (
      <Typography variant="body" size="small" color="black" theme={theme}>
        {record.appointmentLocationName || '-'}
      </Typography>
    ),
  },
  {
    key: 'testDriveStatus',
    title: labels.status || 'Status',
    width: '130px',
    sortable: true,
    render: (_: unknown, record: ProspectTestDrive) => (
      <Badge
        label={getTestDriveStatusLabel(record.testDriveStatus, labels)}
        color={getTestDriveStatusBadgeColor(record.testDriveStatus)}
        type="secondary"
        theme={theme === 'dark' ? 'light' : 'dark'}
        minWidth="60px"
      />
    ),
  },
  {
    key: 'action',
    title: labels.action || 'Action',
    width: '120px',
    align: 'center' as const,
    sortable: false,
    render: (_: unknown, record: ProspectTestDrive) => (
      <Button
        variant="button"
        type="primary"
        color="neutral"
        size="small"
        label={labels.view || 'View'}
        handleClick={() => onViewClick(record)}
        gaComponent="test-drive-view"
        dataTestId={`test-drive-view-${record.testDriveScheduleId}`}
        theme={theme === 'dark' ? 'light' : 'dark'}
      />
    ),
  },
];
